export function video() {
    let videoHolder = $(".video-holder");
    videoHolder.on("click", ".play-button", function (e) {
        e.preventDefault();

        const parent = $(this).closest(".video-holder");
        const commandPlay = {
            "event": "command",
            "func": "playVideo"
        };
        const src = $(this).attr("href") + '?enablejsapi=1&autoplay=1';
        const video = '<iframe src="' + src + '" frameborder="0" allow="autoplay" allowfullscreen playsinline></iframe>'

        parent.append(video);
        setTimeout(() => {
            parent.find('iframe')[0].contentWindow.postMessage(JSON.stringify(commandPlay), "*");
        }, 700);

        if (!parent.hasClass("video-play")) {
            parent.find('iframe')[0].contentWindow.postMessage(JSON.stringify(commandPlay), "*");
            parent.addClass("video-play");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/video.js